
export const SampleBadgeDifferentOrder = () => {
    return (
        <span className="badge li-bg-danger ml-2 li-fg-white">DIFFERENT ORDER</span>
    );
};